<template>
  <v-container class="pa-0">
  <v-overlay :opacity="0.3" :value="isLoading || isError" class="text-center" color="#2c3c4d"
             style="height: 100vh">
    <v-progress-circular v-if="isLoading" indeterminate size="64"></v-progress-circular>
    <v-dialog :value="isError" class="d-flex flex-column align-center rounded-xl" width="300" overlay-color="#2c3c4d" content-class="elevation-0">
      <v-card class="pt-1 rounded-xl">
        <h2 class="mt-10 mb-4 text-center font-B2-semi-bold">Что-то пошло не так</h2>
        <div v-for="(message, messageIndex) in errors" :key="messageIndex">
          <div class="text-center" v-for="(line, lineIndex) in message ? message.split('\n') : []" :key="lineIndex">
            {{ line }}
          </div>
        </div>
        <v-container v-if="isError" class="d-flex justify-center">
          <v-btn :style="{ backgroundColor: colorButton, color: colorText }" style="border-radius: 48px; text-transform: none; font-size: 16px !important;" class="mb-10 mt-2" height="52" width="216" @click="onDlgChange(false)">Закрыть окно</v-btn>
        </v-container>
      </v-card>
    </v-dialog>
  </v-overlay>

  </v-container>
</template>

<script>
import { PROGRESS_STATE_ERROR, PROGRESS_STATE_IN_PROGRESS } from '@/store/const-progress';
import { MUTATION_PROGRESS_NONE } from '@/store/const-mutations';
export default {
  name: 'gk-progress',

  props: {
    tag: { type: String, default: null }
  },

  computed: {
    isLoading: (vm) => vm.isInProgressStateAndTag(PROGRESS_STATE_IN_PROGRESS),

    isError: (vm) => vm.isInProgressStateAndTag(PROGRESS_STATE_ERROR),

    colorButton: (vm) => vm.$store.state.data.configuration.colorButton,

    colorText: (vm) => vm.$store.state.data.configuration.colorText,

    errors: function () {
      if (this.isError) {
        const errors = this.$store.state.progress.error.errors || [];
        const error = this.$store.state.progress.error;

        if (errors.length > 0) {
          return errors.map((item) => this.extractErrorMessage(item.message));
        } 
        else if (error && error.error) {
          return [this.extractErrorMessage(error.error.message)];
        }
      }
      return [];
    }
  },

  methods: {
    isInProgressStateAndTag: function (state) {
      if (!this.$store.state.progress)
        return false;
      if (this.$store.state.progress.state === state) {
        if (this.tag !== null && this.tag !== undefined) {
          return this.$store.state.progress.tag === this.tag;
        }
        return true;
      }
      else
        return false;
    },

    extractErrorMessage: function (errorMessage) {
      const searchString = 'Mixed sale of tickets and other products is impossible. ';
      const delimiterIndex = errorMessage.indexOf(searchString);
      if (delimiterIndex !== -1) {
      // Если найдена искомая фраза, возвращаем часть строки после неё
        return errorMessage.substring(delimiterIndex + searchString.length);
      } 
      else {
      // Если не найдена, возвращаем всю строку как есть
        return errorMessage;
      }
    },

    onDlgChange: function (value) {
      if (value === false) {
        // Снимаем ошибку в хранилище
        this.$store.commit(MUTATION_PROGRESS_NONE);
      }
    }
  }
};
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}
</style>
